export enum GameModes {
    UNDEFINED_GAME_MODE = 'UNDEFINED_GAME_MODE',
    CRASH = 'crash',
    DICE = 'dice',
    MINES = 'mines',
    DOUBLE = 'double',
    TOWER = 'tower',
    JACKPOT = 'jackpot',
    HILO = 'hilo',
    FRUITS = 'fruits',
    PROV1 = 'provider1',
    CRYPTOS = 'cryptos',
    TEEN_PATTI_EXPRESS = 'teenPattyExpress',
    LUDO = 'ludo',
    DRAGON_TIGER = 'dragon-tiger',
    RUMMY = 'rummy',
    DIVER = 'diver',
    NEW_DOUBLE = 'new-double',
    NEW_HILO = 'new-hilo',
    NEW_DICE = 'robo-dice',
    // B2BSLOTS = "B2BSLOTS"
    NEW_TOWER = 'goblin-tower' //'new-tower'
}
